import http from "../../helpers/http";
import { doObjToFormData } from "../../helpers/helpers";

// POST /api/submit-referral
//
// Body (form-data):
//   token                    — referrer auth (current user)
//   their_company_name       — referrer's own company (auto-filled from
//                              member.mem_business but editable)
//   referral_company_name    — referee's company
//   referral_contact_name    — referee contact's full name
//   referral_phone           — referee phone (raw user input; backend should
//                              normalize)
//   referral_email           — referee email
//
// Expected response shape:
//   { status: 1, msg: "Thanks — we've passed the referral to the team." }
//   { status: 0, msg: "<reason>", code?: "self_referral" | "duplicate" |
//                                       "existing_customer" | "validation" }
//
// Backend responsibilities (out of scope for this PR but documented for
// the handoff):
//   - notify support@rhinorecon.com (and optionally the referrer)
//   - persist for the admin dashboard with status enum:
//     submitted → contacted → signed_up → paying → reward_issued / disqualified
//   - reject: self-referral (email matches referrer's), duplicate open row,
//     referee email already in members table
//   - email-match attribution: on /signup, check if the new email matches an
//     open referral row → flip status to signed_up and link

export const submitReferral = (formData) => () =>
  http
    .post(
      "submit-referral",
      doObjToFormData({
        token: localStorage.getItem("authToken"),
        ...formData,
      })
    )
    .then(({ data }) => data);
